import { render, staticRenderFns } from "./SelectedProduct.vue?vue&type=template&id=ca900908&scoped=true&"
import script from "./SelectedProduct.vue?vue&type=script&lang=js&"
export * from "./SelectedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProduct.vue?vue&type=style&index=0&id=ca900908&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca900908",
  null
  
)

export default component.exports